import { BufferGeometry, Float32BufferAttribute, Vector3 } from "three"

/**
 * Turns a 2D array of Vector3s (rows × cols) into a mesh surface.
 */
export default function createSurfaceFromPointsGridGeometry(
  points: Vector3[][],
  isHorizontal: boolean,
): BufferGeometry {
  const rowCount = points.length
  const colCount = points[0].length

  const positions: number[] = []
  for (let r = 0; r < rowCount; r++) {
    for (let c = 0; c < colCount; c++) {
      const p = points[r][c]
      positions.push(p.x, p.y, p.z)
    }
  }

  const indices: number[] = []
  for (let r = 0; r < rowCount - 1; r++) {
    for (let c = 0; c < colCount - 1; c++) {
      const i = r * colCount + c
      const iRight = i + 1
      const iBelow = i + colCount
      const iBelowRight = i + colCount + 1

      if (isHorizontal) {
        // Two triangles per quad
        indices.push(i, iBelow, iRight)
        indices.push(iRight, iBelow, iBelowRight)
      } else {
        // Two triangles per quad
        indices.push(i, iRight, iBelow)
        indices.push(iRight, iBelowRight, iBelow)
      }
    }
  }

  const geometry = new BufferGeometry()
  geometry.setAttribute("position", new Float32BufferAttribute(positions, 3))
  geometry.setIndex(indices)
  geometry.computeVertexNormals()

  return geometry
}
